import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { Router } from "@angular/router";
import { SetFlowOrigin } from "@edp-store/actions/smart-now.actions";

@Component({
    selector: "edp-widget-smart-now",
    templateUrl: "./edp-widget-smart-now.component.html",
    styleUrls: ["./edp-widget-smart-now.component.scss"],
})
export class EdpWidgetSmartNowComponent {
    constructor(private store: Store<IAppState>, private router: Router) {}

    openSmartnow() {
        this.store.dispatch(new SetFlowOrigin(this.router.url));
        this.router.navigate(["/smart-now"]);
    }
}
